import React, { useState } from "react";

import { graphql, useMutation } from "react-relay";
import { useAlert } from "../../common/Alert";
import { IntegrationQuinyxCreateScreenMutation } from "./__generated__/IntegrationQuinyxCreateScreenMutation.graphql";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { IntegrationLogo } from "./components/Logos/Logos";

export function IntegrationQuinyxCreateScreen(
  props: StoreAdminNavigationScreenProps<"IntegrationQuinyxCreate">
) {
  const [apiKey, setApiKey] = useState("");

  const [addMutation, pending] =
    useMutation<IntegrationQuinyxCreateScreenMutation>(graphql`
      mutation IntegrationQuinyxCreateScreenMutation($apiKey: String!) {
        store {
          activateIntegrationQuinyx(apiKey: $apiKey) {
            id
          }
        }
      }
    `);

  const Alert = useAlert();
  const add = () => {
    if (pending) {
      return;
    }
    addMutation({
      onError: () => {
        Alert.error("Fel inträffade");
      },
      onCompleted: (v) => {
        props.navigation.goBack();
      },
      variables: {
        apiKey,
      },
    });
  };

  return (
    <IntegrationActivateScreen
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="quinyx" />}
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={apiKey}
          onChangeText={setApiKey}
          type="api-key"
        />
      }
      onActivate={add}
      isValid={apiKey.length > 0}
      isActivating={pending}
    />
  );
}
